import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateChildFn,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { LipoRouteEnum } from '../../shared/enums/lipo-route.enum';
import { AuthGuardData, createAuthGuard } from 'keycloak-angular';
import { environment } from '../../../environments/environment';

const isAccessAllowed = async (
  route: ActivatedRouteSnapshot,
  _: RouterStateSnapshot,
  authData: AuthGuardData,
): Promise<boolean | UrlTree> => {
  const { authenticated, grantedRoles } = authData;
  const router = inject(Router);

  if (!authenticated) {
    return router.createUrlTree([LipoRouteEnum.AUTH, LipoRouteEnum.REALM_CHOOSER]);
  }

  if (!grantedRoles.realmRoles.some((it) => it.startsWith(environment.allowedRole))) {
    return router.createUrlTree([LipoRouteEnum.NOT_ALLOWED]);
  }

  const requiredRoles: string[] | undefined = route.data['roles'];
  if (!requiredRoles || requiredRoles.length === 0) {
    return true;
  }

  const hasRequiredRole = requiredRoles.some((role) => grantedRoles.realmRoles.includes(role));
  return hasRequiredRole ? true : router.createUrlTree([LipoRouteEnum.NOT_ALLOWED]);
};

export const canActivateAuthRole = createAuthGuard<CanActivateChildFn>(isAccessAllowed);
